import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface PutCustomerEventContentRequest {
    id: number;
    event_content_idx: number[];
}
export const usePutCustomerEventContent = (
    successCallback?: () => void,
): UseMutationResult<null, Error, PutCustomerEventContentRequest, unknown> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, PutCustomerEventContentRequest>({
        mutationFn: async ({ id, event_content_idx }: PutCustomerEventContentRequest) => {
            const response = await axios.put(
                `${enum_api_uri.put_customer_event_content.replace(":customer_idx", id.toString())}`,
                { event_content_idx },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                },
            );
            return response.data.data;
        },
        onSuccess: () => {
            successCallback?.();
        },
    });
};
